<style lang="scss" rel="stylesheet/scss" scoped>
</style>
<style lang="scss" rel="stylesheet/scss">
#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}
#card-element {
  border-radius: 4px 4px 0 0;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}
#card-error {
  color: red;
}
/**
 * Extracted from: SweetAlert
 * Modified by: Istiak Tridip
 */
.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;
}
.success-checkmark .check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid #4caf50;
}
.success-checkmark .check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}
.success-checkmark .check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotate-circle 4.25s ease-in;
}
.success-checkmark .check-icon::before,
.success-checkmark .check-icon::after {
  content: "";
  height: 100px;
  position: absolute;
  background: #ffffff;
  transform: rotate(-45deg);
}
.success-checkmark .check-icon .icon-line {
  height: 5px;
  background-color: #4caf50;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}
.success-checkmark .check-icon .icon-line.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 0.75s;
}
.success-checkmark .check-icon .icon-line.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 0.75s;
}
.success-checkmark .check-icon .icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgba(76, 175, 80, 0.5);
}
.success-checkmark .check-icon .icon-fix {
  top: 8px;
  width: 5px;
  left: 26px;
  z-index: 1;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #ffffff;
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
</style>

<template>

  <div style="">
      <!-- -->
    <form id="sign-in-form" @submit.prevent="submit()">
    <v-layout row wrap>
 
      <v-flex xs12>
        <v-flex
          xs12
          style="padding-left: 10px; padding-right: 10px; text-align: center"
        >
          <h3 class="title" v-if="topUpSuccessful">
            Electricity Purchase Successful
          </h3>
          <h3 class="title" v-else>Buy Electricity</h3>
          <h1>{{ formatPrice(toValue, "GMD") }} <span v-if="paymentIntentResult && initialBalanceFormatted == paymentIntentResult.unitsPayment"> ({{ paymentIntentResult.units }} KWh)</span></h1>

        </v-flex>

        <template v-if="topUpSuccessful">
          <div class="success-checkmark">
            <div class="check-icon">
              <span class="icon-line line-tip"></span>
              <span class="icon-line line-long"></span>
              <div class="icon-circle"></div>
              <div class="icon-fix"></div>
            </div>
          </div>
          <div style="width: 100%; text-align: center;">Top up token sent to {{ mobileNumber }}</div>
          <v-btn
              @click="reset()"
              color="info"
              style="width: 100%"
            >
              New Transaction 
            </v-btn>
            <v-btn
              @click="close()"
              color="red"
              class="white--text "
              style="width: 100%"
            >
              Close
            </v-btn>
        </template>

        <template v-else>
          <v-flex xs12>
            <div style="min-height: 65px">
              <v-alert
                v-if="showError"
                :value="showError"
                color="error"
                icon="warning"
                outline
              >
                {{ errorMessage }}
              </v-alert>
              <!-- <span v-else class="caption">Enter Amount And Card Details</span> -->
            </div>
          </v-flex>
          <!-- v-validate="'required'" :error-messages="errors.collect('meterNumber')"-->

          <v-flex xs12 style="padding-left: 10px; padding-right: 10px">
            <v-text-field
            
              :prefix="''"
              v-model="meterNumber"
              label="Enter Meter Number"
              name="meterNumber"   
              :disabled="step == 'confirm' ? true: false"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 style="padding-left: 10px; padding-right: 10px">
            <v-text-field
              :prefix="''"
              v-model="mobileNumber"
              label="Enter Mobile Number"
              name="mobileNumber" 
              :disabled="step == 'confirm' ? true: false"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 style="padding-left: 10px; padding-right: 10px">
            <v-text-field
              :prefix="currency"
              v-model="initialBalanceFormatted"
              label="Enter Amount"
              name="amount"  
              :disabled="step == 'confirm' ? true: false"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            style="padding-left: 5px; padding-right: 10px; padding-top: 5px"
          >
            <v-btn
              color="info"
              style="width: 100%"
              v-if="!initialBalance"
              :disabled="true"
              :loading="loading"
            >
              Buy Electricity
            </v-btn>
            <!-- @click="submitPayment()" -->
            <v-btn
              v-if="step != 'confirm' && initialBalance"
              type="submit"
              color="info"
              style="width: 100%"
              :loading="loading"
            >
              Purchase {{ formatPrice(initialBalance, "GMD") }}
            </v-btn>
            <v-btn
              v-if="step == 'confirm' && initialBalance"
              type="submit"
              color="info"
              style="width: 100%"
              :loading="loading"
            >
              Confirm Purchase {{ formatPrice(initialBalance, "GMD") }}
            </v-btn>
            <v-btn
              @click="reset()"
              color="error"
              style="width: 100%"
            >
              Reset 
            </v-btn>
          </v-flex>
        </template>
      </v-flex>
    </v-layout>
    </form>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";

function formatAsCurrency(value, dec) {
  dec = dec || 0;
  if (!value) {
    return null;
  }
  return Number(value).toFixed(dec);
}

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = "") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    console.log(e);
  }
}

export default {
  name: "buy-electricity",
  props: ['module'],
  data: function () {
    return {
      validForm: false,
      meterNumber: null, 
      card: null,
      topUpSuccessful: false,
      showError: false,
      errorMessage: null,
      stripe: null,
      token: null,
      loading: false,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      amountValue: null,
      amount: null,
      cardError: true,
      mobileNumber: null,
      currency: "GMD",
      initialBalance: 0.0,
      toValue: 0.0,
      exchangeRate: 66.2,
      paymentIntentResult: null,
      step: 'insert',
      amounts: [
        { id: "100", value: 100, service: "electricity" },
        { id: "500", value: 500, service: "electricity" },
        { id: "750", value: 750, service: "electricity" },
        { id: "1000", value: 1000, service: "electricity" },
        { id: "1500", value: 1500, service: "electricity" },
        { id: "2000", value: 2000, service: "electricity" },
      ],
    };
  },
  components: {
  },
  computed: {
    initialBalanceFormatted: {
      get: function () {
        return this.initialBalance == 0 ? null : this.initialBalance;
        // return formatAsCurrency(this.initialBalance, 2)
      },
      set: function (setValue) {
        // console.log(typeof newValue);
        let newValue = setValue;

        try {
            newValue = Number(newValue).toFixed(2);
        } catch(erro) {

        }
        const initialBalance = typeof newValue !== 'string' ? Number(value).toFixed(2) : Number.parseFloat(
          newValue.replace(/[^0-9\.]/g, "") 
        );
 
        // console.log("initialBalance", initialBalance);
        this.initialBalance = isNaN(initialBalance) ? 0.0 : initialBalance;
        const toValue = initialBalance;
        this.toValue = isNaN(toValue) ? 0.0 : toValue;
      },
    },
  },
  methods: {
    reset() {
      //  alert("reset");
      this.step = "insert";
      this.meterNumber = null;
      this.mobileNumber = null;
      this.amountValue = null;
      this.amount = null;
      this.paymentIntentResult = null;
      this.initialBalanceFormatted = 0;
      this.topUpSuccessful = false;
      this.showError = false;
    },
    close() {
        try {
            this.reset();
            this.module.closeDialog();
        } catch(error) {

        }
    },
    submit() {
      // const 
      const that = this;
      const createPaymentIntent = this.createPaymentIntent;
      const confirmPayment = this.confirmPayment;
      if(that.step === "confirm") {
              confirmPayment();
            } else {
              createPaymentIntent();
            }
    //   this.$validator.validateAll().then(function(response) {
    //       if(response === true) { 
    //         if(that.step === "confirm") {
    //           confirmPayment();
    //         } else {
    //           createPaymentIntent();
    //         }
    //       }
    //   }).catch(function(e) {});
    },
    formatPrice(value, currency) {
      const formatter = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency,
        //  These options are needed to round to whole numbers if that's what you want.
        //  minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });

      return formatter.format(value);
    },
    setAmount(item) {
      if (this.amount && this.amount.value == item.value) {
        this.amountValue = null;
        this.amount = null;
      } else {
        this.amount = item;
        // console.log("amount", item);
        this.amountValue = item.value;
      }
    },
    async createPaymentIntent() {
      // /electricity-purchase/create-payment-intent
      // alert("createPaymentIntent");

      const that = this;

      const params = {
        meterNumber: this.meterNumber,
        mobileNumber: this.mobileNumber,
        amount: this.initialBalanceFormatted
      };
      this.loading = true;
      this.showError = false;
      try {
        const response = await ApiService.post(
          "/service/electricity-purchase/create-payment-intent",
          params
        );
        const data = response.data;
        that.paymentIntentResult = data;
        that.initialBalanceFormatted = that.initialBalance = data.unitsPayment;
        that.step = "confirm";
        this.loading = false;
        // this.confirmPayment(this.stripe, this.card, data.secret);
      } catch (error) {
        this.showError = true;
        try {
          this.errorMessage = error.response.data.message;
        } catch (e) {
          this.errorMessage = error.message;
        }

        this.loading = false;
        // console.log("error.response", error.response);
        // console.log("error", JSON.stringify(error));
      }

      // console.log("that.step", that.step);

      

      // ApiService.pos
    },
    async confirmPayment() {
      this.loading = true;
      this.showError = false;
      const that = this;
      
      

      try {
        const params = {
          secret: that.paymentIntentResult.secret
        };
        const response = await ApiService.post(
          "/service/electricity-purchase/confirm",
          params
        );
        that.topUpSuccessful = true;
        that.showError = false;
        that.loading = false;
        const intentParams = {
          action: "SENDSMS",
          target: that.mobileNumber,
          secret: that.paymentIntentResult.secret
        };
        ApiService.post(
          "/service/electricity-purchase/action",
          intentParams
        ).then((r) => {

        });
      } catch(error) {
        that.loading = false;
        that.showError = true;
        try {
          this.errorMessage = error.response.data.message;
        } catch (e) {
          this.errorMessage = error.message;
        }
      }

    },
  },
  mounted() {

  },
  beforeDestroy() {
    // this.cardNumber.destroy();
    // this.cardExpiry.destroy();
    // this.cardCvc.destroy();
  },
};
</script>